import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import IconCheck from '@/components/icons/check.vue'
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'
export default {
    name: 'NewBusinessFDALegalService',
    components: {
        IconArrowBack,
        IconBase,
        IconCheck,
        IconForwardBack,
        BackButton,
        NextButton
     },
    props: {
        title: String,
        instruction: String
    },
    data() {
        return {
            selectedLegalService: [],
            legalServiceOption: [
                {
                    id: 1,
                    legal_option_label: 'Telephone Legal Advice',
                    legal_option_amount: '110.00',
                    checked: false
                },
                {
                    id: 2,
                    legal_option_label: 'Debt Recovery',
                    legal_option_amount: '100.00',
                    checked: false
                }
            ],
            FDALegalServiceSubmitted: false
        }
    },
    methods: {
        checkStoreData() { 
            console.debug('Payload Build Structure', this.$store.getters.sessionPayload);
        },
        backToPrevious() {
            this.$store.commit('mutate', {
                property: "NewBusinessStep",
                value: this.$store.state.NewBusinessStep - 1
            });
        },
        initApp() {
            this.checkStoreData();
        },
        repopulateSelectedOption(option_data, current_option_index) {

        },
        selectLegalServiceOption(legal_option) {
            switch(legal_option) {
                case 'Telephone Legal Advice':

                    let posOption1 = this.selectedLegalService.map(function(e) { return e.legal_option_label; }).indexOf('Telephone Legal Advice');
                    this.repopulateSelectedOption();

                    if(this.legalServiceOption[0].checked == false) {
                        this.legalServiceOption[0].checked = true;
                        this.selectedLegalService.push(this.legalServiceOption[0])
                    } else {
                        this.legalServiceOption[0].checked = false;
                        this.selectedLegalService.splice(this.legalServiceOption[posOption1], 1);
                    }
                break;

                case 'Debt Recovery':

                    let posOption2 = this.selectedLegalService.map(function(e) { return e.legal_option_label; }).indexOf('Debt Recovery');

                    if(this.legalServiceOption[1].checked == false) {
                        this.legalServiceOption[1].checked = true;
                        this.selectedLegalService.push(this.legalServiceOption[1])
                    } else {
                        this.legalServiceOption[1].checked = false;
                        this.selectedLegalService.splice(this.legalServiceOption[posOption2], 1);
                    }

                break;

                default:
                    // do nothing
                break;
            }
        },

        mutateLegalOptionState(coverCode, coverCodeLabel) {

            this.$store.commit('mutate', {
                property: 'sessionDetails.properties.additional_cover',
                value: coverCodeLabel
            });
            this.$store.commit('mutate', {
                property: 'sessionDetails.properties.additional_cover_code',
                value: coverCode
            });

        },

        getFormattedAddresses() {
            const _type = this.$store.state.sessionDetails.properties.user_type === "educator" ? "addresses" : "additional_branches";
            const _type_text = this.$store.state.sessionDetails.properties.user_type === "educator" ? "address" : "additional_branch";
            if(this.$store.state.sessionDetails.properties.length < 1) { return []; }
            let _formatted_addresses = []; 
            for(let i = 0; i < this.$store.state.sessionDetails.properties.length; i++) {
               const _item = thithis.$store.state.sessionDetails.properties[i];
               let _address = {};
  
                _address.id = _item.id;
                _address.type = _type_text;
                if(this.draft.user_type === "service") { _address.service_name = _item.service_name }
                _address.is_risk_address = _item.is_risk_address;
                _address.is_mailing_address = _item.is_mailing_address;
                _address.address = {};
                _address.address.address1 = _item.address1;
                _address.address.address2 = _item.address2;
                _address.address.suburb = _item.suburb;
                _address.address.state = _item.state;
                _address.address.postcode = _item.postcode;
                _address.address.country = _item.country;

                _formatted_addresses.push(_address); 
            }
            return _formatted_addresses;
        },
        formatPayload(key, values, index) {
            let toFormat = ['addresses', 'insured_address', 'mailing_address', 'relief_educators', 'activities', 'dual_educators', 'registered_service', 'additional_branches', 'interested_parties'];
            
            if(index == "insured_address"){
                let temp_insured_address = values[index];
                values[index] = temp_insured_address[0].address;
            }

            let formattedString = values[index] ? JSON.stringify(JSON.stringify(values[index])) : '';
            let data = values[index];
            if (toFormat.indexOf(key) >= 0 && formattedString)
                data = formattedString.substring(1, formattedString.length - 1);
            return data;
        },
        createPayloadStructureAndStringify(fields) {  
            let payload = { 
                properties: {} 
            } 
  
            const values = Object.values(fields); 
            const keys = Object.keys(fields); 
 
            keys.forEach((item, i) => { 
                if (typeof values[i] === "boolean"){
                    payload.properties[keys[i]] = values[i] ? "true": "false" 
                } else {
                    payload.properties[keys[i]] = this.formatPayload(keys[i], values, i);
                }
            }); 

            payload.properties.outstanding_claims = payload.properties.existing_claims
            delete payload.properties.existing_claims
            delete payload.properties.additional_cover_code
            
            delete payload.properties.endorsement_id
            delete payload.properties.pl_limit
            delete payload.properties.coordination_unit
            delete payload.properties.amount_exceed_flag
            delete payload.properties.terms_agreement_flag
            delete payload.properties.last_step
            delete payload.properties.qualified_flag
            delete payload.properties.abandon_log_flag
            delete payload.properties.is_deleted
            delete payload.properties.evidence_of_insurance_url
            delete payload.properties.financial_services_guide_url
            delete payload.properties.letter_of_cancellation_url
            delete payload.properties.official_receipt_and_tax_invoice_url
            delete payload.properties.customer_id
            delete payload.properties.generate_insurance_docs
            delete payload.properties.generate_membership_doc
            delete payload.properties.generate_cancellation_docs
            delete payload.properties.email_insurance_docs
            delete payload.properties.email_membership_doc
            delete payload.properties.email_cancellation_docs
            delete payload.properties.due_for_renewal

            return payload; 
        }, 
        getInstanceEnvironment() {
            let env = ""
            switch (window.location.origin) {
                case 'https://fda-insurance.prod01.sydney.platformos.com':
                case 'https://insurance.familydaycare.com.au':
                    env = 'prod';
                    break;
                default:
                    env = 'staging';
                    break;
            }
            this.$store.commit('mutate', {
                property: "env",
                value: env
            });
            return env;
        },
        generateQuoteReferenceId(length) {
            let result = '',
                characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
                charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result.toUpperCase();
        },
        async submitForm() {

            let self = this;

            if (this.selectedLegalService.length == 2) {
                self.mutateLegalOptionState("BT", "telephone legal assistance,debt recovery");
            } else {
                this.selectedLegalService.forEach(function(data) {
                    if(data.legal_option_label == "Debt Recovery") {
                        self.mutateLegalOptionState("DR", "debt recovery");
                    }
                    if(data.legal_option_label == "Telephone Legal Advice") {
                        self.mutateLegalOptionState("TL", "telephone legal assistance");
                    }
                });
            }
            
            this.FDALegalServiceSubmitted = true;
            this.$emit("createUpdateSession");
            this.getInstanceEnvironment();
        }
    },
    mounted() {
        this.initApp();
    }
}